"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugSurfaceCleanupSystem = void 0;
var core_1 = require("@inter-ikea-core/core");
var SystemBase2_1 = require("../systembase/SystemBase2");
var ViewerSurfaceReferenceComponent_1 = require("./ViewerSurfaceReferenceComponent");
/*
 * Companion to the DebugSurfaceDrawingSystem, is responsible for cleaning up the viewer objects created when adding or
 * updating DebugSurfaces.
 */
var DebugSurfaceCleanupSystem = /** @class */ (function (_super) {
    __extends(DebugSurfaceCleanupSystem, _super);
    function DebugSurfaceCleanupSystem(entityManager) {
        var _this = _super.call(this, ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent.ID, core_1.ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID) || this;
        _this.systemsAfterMe = null;
        _this.systemsBeforeMe = ["DebugSurfaceDrawingSystem"];
        _this.doingChangesOnComponent = [];
        _this.id = DebugSurfaceCleanupSystem.ID;
        _this.entityManager = entityManager;
        return _this;
    }
    DebugSurfaceCleanupSystem.prototype.onAddComponent = function (_entity, _newComponent) {
        // Do nothing
    };
    DebugSurfaceCleanupSystem.prototype.onRemoveComponent = function (entity, oldComponent) {
        DebugSurfaceCleanupSystem.removeOldObjects(oldComponent);
    };
    DebugSurfaceCleanupSystem.prototype.onUpdateComponent = function (entity, oldComponent, _newComponent) {
        DebugSurfaceCleanupSystem.removeOldObjects(oldComponent);
    };
    DebugSurfaceCleanupSystem.removeOldObjects = function (oldComponent) {
        oldComponent.viewerObjects.forEach(function (it) {
            it.deleteObject();
        });
    };
    DebugSurfaceCleanupSystem.prototype.onAddComponent2 = function (_entity, newComponent) {
        var _a;
        var oldViewerSurfaceReferenceComponent = (_a = newComponent.entityStateBeforeLoadingSnapshot) === null || _a === void 0 ? void 0 : _a.getComponent(ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent.ID);
        if (oldViewerSurfaceReferenceComponent) {
            DebugSurfaceCleanupSystem.removeOldObjects(oldViewerSurfaceReferenceComponent);
        }
    };
    DebugSurfaceCleanupSystem.prototype.onRemoveComponent2 = function (_entity, _oldComponent) {
        //NIL
    };
    DebugSurfaceCleanupSystem.prototype.onUpdateComponent2 = function (_entity, _oldComponent, _newComponent) {
        //NIL
    };
    DebugSurfaceCleanupSystem.ID = "DebugSurfaceCleanupSystem";
    return DebugSurfaceCleanupSystem;
}(SystemBase2_1.SystemBase2));
exports.DebugSurfaceCleanupSystem = DebugSurfaceCleanupSystem;
//# sourceMappingURL=DebugSurfaceCleanupSystem.js.map